module.exports = __webpack_public_path__ + "media/printed-materials/educators-materials-resources-1b447219.png";